import React from "react";
import { Link } from "react-router-dom";
import "./Homepage.css";

import yogurtImage from "./Images/yogurt.png";
import weatherImage from "./Images/weather.png";
import dictionaryImage from "./Images/dictionary.png";

export default function Homepage() {
  return (
    <div className="Homepage">
      <section className="hero">
        <p>👋 Hi I am</p>

        <h1>Lina Moramaga</h1>

        <h2 className="mb-5">Front-end developer, based in South Africa</h2>

        <Link to="/contact" className="btn btn-branding">
          Contact me
        </Link>
      </section>

      <h2 className="text-center my-5">Featured Projects</h2>

      <section className="container">
        <div className="row mb-5 align-items-center">
          <div className="col-lg-6 col-md-12 mb-4">
            <img
              src={yogurtImage}
              className="img-fluid rounded"
              alt="Yogurt preview"
            />
          </div>

          <div className="col-lg-6 col-md-12">
            <div className="project-description">
              <h2 className="mb-4">Yogurt App</h2>

              <p className="mb-4 text-muted">
                I entered the world of front-end development by gaining
                knowledge in HTML, CSS, and JavaScript. I used these skills
                together with VS Code to build a landing page about Yogurt. The
                page uses JavaScript functions to create user interaction.
              </p>

              <Link to="/work" className="btn btn-branding-outline">
                Learn more
              </Link>
            </div>
          </div>
        </div>

        <div className="row mb-5 align-items-center">
          <div className="col-lg-6 col-md-12 order-lg-1 order-2">
            <div className="project-description">
              <h2 className="mb-4">Weather App</h2>

              <p className="mb-4 text-muted">
                I built a Vanilla JavaScript weather app in SheCodes Plus. I
                improved my skills in Bootstrap, APIs, JavaScript, hosting, and
                real-life development workflow.
              </p>

              <Link to="/work" className="btn btn-branding-outline">
                Learn more
              </Link>
            </div>
          </div>

          <div className="col-lg-6 col-md-12 order-lg-2 order-1 mb-4">
            <img
              src={weatherImage}
              className="img-fluid rounded"
              alt="Weather preview"
            />
          </div>
        </div>

        <div className="row mb-5 align-items-center">
          <div className="col-lg-6 col-md-12 mb-4">
            <img
              src={dictionaryImage}
              className="img-fluid rounded"
              alt="Dictionary preview"
            />
          </div>

          <div className="col-lg-6 col-md-12">
            <div className="project-description">
              <h2 className="mb-4">Dictionary App</h2>

              <p className="mb-4 text-muted">
                I developed my React skills by building a working dictionary
                application using APIs and modern front-end development
                practices.
              </p>

              <Link to="/work" className="btn btn-branding-outline">
                Learn more
              </Link>
            </div>
          </div>
        </div>
      </section>

      <p className="text-center mt-5 mb-5">
        This project was coded by Lina Moramaga and is{" "}
        <a
          href="https://github.com/lmoramaga/my-project"
          target="_blank"
          rel="noopener noreferrer"
        >
          open-sourced
        </a>{" "}
        and hosted on{" "}
        <a
          href="https://my-project-p4ij.onrender.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Render
        </a>
      </p>
    </div>
  );
}
